import _ from 'lodash';
import { getUser } from '~src/user';
import editorConfig from '~config/editorConfig';
import { mixpanel, debug, isLocalhost } from './config/mixpanelConfig';

const trackZohoCustomAction = (eventName) => {
  try {
    if (window.$zoho && window.$zoho.salesiq && window.$zoho.salesiq.visitor) {
      // Track as custom action in Zoho (max 250 chars)
      const truncatedAction = eventName.substring(0, 250);
      window.$zoho.salesiq.visitor.customaction(truncatedAction);

      if (debug) {
        console.log('[Zoho SalesIQ] Tracked custom action:', truncatedAction);
      }
    }
  } catch (error) {
    console.error('Error tracking event in Zoho Sales IQ', error);
  }
};

export const trackEvent = (eventName = '', options = {}) => {
  if (isLocalhost) {
    return;
  }
  getUser().then(({ user }) => {
    if (
      (editorConfig.excludeFromTrackingOrgsIds.includes(
        user.org_pointer.objectId
      ) ||
        editorConfig.excludeFromTrackingOrgsNames.includes(
          user.org_pointer.nome
        )) &&
      !debug
    ) {
      console.debug(
        `[tracking] excluding orgId: ${user.org_pointer.objectId} orgName: ${user.org_pointer.nome}`
      );
      return;
    }

    const eventData = {
      ...options,
      app: 'giotto',
    };

    try {
      mixpanel.track(eventName, eventData);
    } catch (error) {
      console.error('Error tracking event in Mixpanel', error);
    }

    try {
      window.productFruits.api.events.track(eventName, eventData, {
        forwardToIntegrations: true,
      });
    } catch (error) {
      console.error('Error tracking event in Product Fruits', error);
    }

    // Zoho Sales IQ custom action tracking
    trackZohoCustomAction(eventName);

    if (debug) {
      console.log('trackEvent', eventName, options);
    }
  });
};

export const trackEventDebounced = _.debounce(
  (eventName = '', options = {}) => {
    trackEvent(eventName, options);
  },
  3000
);
